(function($) {
    $(document).ready(function() {
        function setHeadersColors() {
            var projectInner = $('.js-project-inner');
            projectInner.find('h2','h3','h4','h5','h6').css('color',projectInner.attr('data-colour'));

            var postInner = $('.js-post-inner');
            postInner.find('h2','h3','h4','h5','h6').css('color',postInner.attr('data-colour'));
        }
        setTimeout(setHeadersColors,0);
    });
})(jQuery);
